import React from "react";
import PageBody from "Common/Custom/PageBody";
import { HeadingOne } from "Common/Custom/HeadingOne";
import FormInput from "Common/Custom/FormInput";
import FormSubmitButton from "Common/Custom/FormSubmitButton";
import FormDatePicker from "Common/Custom/ReactFlatpickr";
import PropTypes from "prop-types";


const FlightForm = ({
    title = "Add Flight",
    fields = [],
    values = {},
    errors = {},
    handleChange = () => { },
    handleSubmit = () => { },
    loading = false,
    btnLabel = "Create"
}) => {
    return (
        <PageBody
            headerchildren={
                <HeadingOne>{title}</HeadingOne>
            }
            onSubmit={handleSubmit}
        >
            {fields.map((field) => {
                if (field.type === "date" || field.type === "datetime-local") {
                    return (
                        <FormDatePicker
                            key={field.name}
                            field={field}
                            value={values[field.name]}
                            handleChange={handleChange}
                            error={errors[field.name]}
                            mode="datetime"
                        />
                    );
                }
                return (
                    <FormInput
                        key={field.name}
                        field={field}
                        value={values[field.name] || ""}
                        handleChange={handleChange}
                        error={errors[field.name]}
                    />
                );
            })}


            <FormSubmitButton
                label={btnLabel}
                loading={loading}
                colSize="col-12"
                align="end"
            />
        </PageBody>
    );
};

FlightForm.propTypes = {
    title: PropTypes.string,
    fields: PropTypes.array,
    values: PropTypes.object,
    errors: PropTypes.object,
    handleChange: PropTypes.func,
    handleSubmit: PropTypes.func,
    loading: PropTypes.bool,
    btnLabel: PropTypes.string,
};

export default FlightForm;
